import * as Tooltip from "@radix-ui/react-tooltip";
import * as Popover from "@radix-ui/react-popover";

const RadixTooltip = ({ Trigger, content, align = "center", alignOffset = 0 }) => {
  return (
    <>
      <span className="radix-desktop-tooltip-root">
        <DesktopTooltip Trigger={Trigger} content={content} align={align} alignOffset={alignOffset} />
      </span>
      <span className="radix-mobile-tooltip-root">
        <MobileTooltip Trigger={Trigger} content={content} align={align} alignOffset={alignOffset} />
      </span>
    </>
  );
};

const DesktopTooltip = ({ Trigger, content, align = "center", alignOffset = 0 }) => {
  return (
    <Tooltip.Provider delayDuration={100}>
      <Tooltip.Root
        className="radix-desktop-tooltip-root"
        delayDuration={0}
        onMouseDown={e => e.preventDefault()}
        onClick={e => e.preventDefault()}
        onKeyDown={e => e.preventDefault()}
      >
        <Tooltip.Trigger
          asChild
          onMouseDown={e => e.preventDefault()}
          onClick={e => {
            e.preventDefault();
          }}
          onKeyDown={e => e.preventDefault()}
        >
          <Trigger />
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            onPointerDownOutside={e => {}}
            avoidCollisions
            align={align}
            alignOffset={-10}
            className="z-[10000] relative transition duration-100 ease-out -translate-y-[2px] drop-shadow"
          >
            <p className="bg-gray-300 rounded-sm px-2 py-1 text-sm source max-w-[35ch] text-center">{content}</p>
            <Tooltip.Arrow className="TooltipArrow" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

const MobileTooltip = ({ Trigger, content, align = "center", alignOffset = 0 }) => {
  return (
    <Popover.Root delayDuration={100}>
      <Popover.Trigger asChild>
        <Trigger />
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          avoidCollisions
          align={align}
          side="top"
          alignOffset={-10}
          className="z-[10000] relative transition duration-100 ease-out -translate-y-[2px] drop-shadow"
        >
          <p className="bg-gray-300 rounded-sm px-2 py-1 text-sm source max-w-[35ch] text-center">{content}</p>
          <Popover.Content />
          <Popover.Arrow className="TooltipArrow" />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export { RadixTooltip };
